import React from "react";
import { cn } from "@/lib/utils";

/**
 * Conteneur mobile-first. Centre le contenu sur desktop (max 480px),
 * plein écran sur mobile, hauteur 100dvh, gestion des safe-areas.
 * header (optionnel) en haut, footer (CTA) fixé en bas.
 */
export const MobileScreen = ({ header, footer, children, className, dataTestId }) => {
    return (
        <div
            data-testid={dataTestId}
            className="w-full max-w-[480px] mx-auto h-[100dvh] bg-black flex flex-col overflow-hidden relative"
        >
            {header ? (
                <div className="shrink-0 safe-top px-5 pt-3">{header}</div>
            ) : (
                <div className="shrink-0 safe-top" />
            )}

            <div
                className={cn(
                    "flex-1 min-h-0 px-5 flex flex-col overflow-hidden",
                    className,
                )}
            >
                {children}
            </div>

            {footer ? (
                <div className="shrink-0 px-5 pt-3 pb-5 safe-bottom bg-black">
                    {footer}
                </div>
            ) : null}
        </div>
    );
};
